export const FORWARD = 'FORWARD'
export const BACKWARD = 'BACKWARD'
export const PAUSE = 'PAUSE'
export const PLAY = 'PLAY'
export const UPDATE_STEP = 'UPDATE_STEP'

export const SLL_CLEAR_ON_DEC = 'SLL_CLEAR_ON_DEC'